import { usePresence } from '../hooks/usePresence';
import { Radio } from 'lucide-react';

/**
 * Small pulsating badge that shows how many listeners are tuned in right now.
 * Inspired by Deluxe Saloon's "live" street-corner feel — reinforces that
 * Patna Ke Presleys is a shared, always-on radio, not just a solo player.
 */
const LiveListenerBadge = ({ variant = 'header' }) => {
  const count = usePresence();
  const label = count === 1 ? '1 listening now' : `${count} listening now`;

  if (variant === 'inline') {
    return (
      <span
        data-testid="live-listener-badge"
        className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[#FF007F]"
      >
        <span className="relative flex w-2 h-2">
          <span className="absolute inset-0 rounded-full bg-[#FF007F] opacity-70 animate-ping" />
          <span className="relative w-2 h-2 rounded-full bg-[#FF007F]" />
        </span>
        {label}
      </span>
    );
  }

  return (
    <div
      data-testid="live-listener-badge"
      className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-[#120505]/70 backdrop-blur border border-[#3D1A1A] text-[#FFF3E0] shadow-[0_2px_10px_rgba(0,0,0,0.35)]"
      title="Listeners tuned in right now"
    >
      <span className="relative flex w-2 h-2">
        <span className="absolute inset-0 rounded-full bg-[#FF007F] opacity-70 animate-ping" />
        <span className="relative w-2 h-2 rounded-full bg-[#FF007F]" />
      </span>
      <Radio className="w-3.5 h-3.5 text-[#FFB800]" />
      <span className="text-[11px] uppercase tracking-[0.2em] font-body">
        <span data-testid="live-listener-count" className="text-[#FFB800] font-bold tabular-nums mr-1">
          {count || '—'}
        </span>
        listening
      </span>
    </div>
  );
};

export default LiveListenerBadge;
